import { IconButton, IconButtonProps, Tooltip, CircularProgress } from '@mui/material';
import Iconify from '../iconify';
import { Box } from '@mui/system';

// ----------------------------------------------------------------------

interface Props extends IconButtonProps {
  loading?: boolean;
  tooltipTitle: string;
}

export default function RefreshIconButton({ loading, tooltipTitle, onClick, sx, ...other }: Props) {
  return (
    <Tooltip title={tooltipTitle}>
      <span>
        <IconButton
          color="primary"
          onClick={onClick}
          disabled={loading}
          sx={{
            width: 40,
            height: 40,
            minWidth: 40,
            minHeight: 40,
            ...sx,
          }}
          {...other}
        >
          <Box
            sx={{
              width: 20,
              height: 20,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              <Iconify icon="mage:reload" />
            )}
          </Box>
        </IconButton>
      </span>
    </Tooltip>
  );
}
